import { CheckmarkCircleFilled, CrossCircle } from '@creditornot/cb-icons';
import { colors, cssThemedValue } from '@creditornot/cb-ingredients';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

import { useDataOptionsTranslations } from './useDataOptionsTranslations';
import { ReportDataOption } from '../../types';

export type DataOptionsDetailsProps = {
  dataOptions: ReportDataOption[];
  selectedDataOptions: ReportDataOption[];
  action?: ReactNode;
};

const DataOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding-block: 16px;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 1fr;
  }
`;

const DataOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const DataOptionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledCheckIcon = styled(CheckmarkCircleFilled)`
  fill: ${colors.lime100};
  width: 12px;
  height: 12px;
`;

const StyledCrossIcon = styled(CrossCircle)`
  fill: ${cssThemedValue('textSecondary')};
  width: 12px;
  height: 12px;
`;

const DataOptionDescription = styled(Typography.Body3)`
  display: flex;
  padding-inline: 20px;
  align-items: flex-start;
  gap: 8px;
  color: ${cssThemedValue('textSecondary')};
`;

export const DataOptionsDetails = ({ dataOptions, selectedDataOptions }: DataOptionsDetailsProps) => {
  const { dataOptionsTranslations, dataOptionsDescriptionsTranslations } = useDataOptionsTranslations();

  return (
    <DataOptionsContainer>
      {dataOptions.map(dataOption => (
        <DataOptionContainer key={dataOption}>
          <DataOptionHeader>
            {selectedDataOptions.includes(dataOption) ? <StyledCheckIcon /> : <StyledCrossIcon />}
            <Typography.Body3>{dataOptionsTranslations[dataOption]}</Typography.Body3>
          </DataOptionHeader>
          <DataOptionDescription>
            <Typography.Body3>{dataOptionsDescriptionsTranslations[dataOption]}</Typography.Body3>
          </DataOptionDescription>
        </DataOptionContainer>
      ))}
    </DataOptionsContainer>
  );
};
